import Vue from 'vue';
import { ApartmentDTO } from '../../../model/ApartmentDTO';
import { BlockDTO } from '../../../model/BlockDTO';

export async function apartmentHeadingData(context: Vue, block: BlockDTO) {
	const apartment = context.$store.pageData.apartment as ApartmentDTO
	const gallery = await context.$resourceService.fetchImages(block.id, "galleryLocation", context.$store.boIdMapping);

	return {
		gallery
	};
}
